//
//  src/layouts/default/Default.js
//
import * as React                   from "react";
import { Routes, Route, useLocation }            from "react-router-dom";
import { persistGclidFromSearch }   from "../../utils/Gclid";
import About                        from "./about/About";
import Home                         from "./home/Home";
import Contact                      from "./contact/Contact";
import ContactForm                  from "./contact/form/Form";
import ErrorNotFound                from "./error/ErrorNotFound";
import Gallery                      from "./gallery/Gallery";
import Location                     from "./location/Location";
import LegalPrivacy                 from "./legal/privacy/Privacy";
import LegalTerms                   from "./legal/terms/Terms";
import MarketingUnsubscribe         from "./marketing/unsubscribe/Unsubscribe";
import "materialize-css/dist/css/materialize.min.css";


//
//  capture [gclid]
//
function GclidSessionSync() {
    const location = useLocation();
    React.useEffect(() => {
        persistGclidFromSearch(location.search);
    }, [location.search]);
    return null;
}


//
//  default
//
export default function Default() {
    return (
        <>
            <GclidSessionSync />
            <main>
                <Routes>
                    <Route path="/"                                     element={ <Home                     /> } />
                    <Route path="/about"                                element={ <About                    /> } />
                    <Route path="/contact"                              element={ <Contact                  /> } />
                    <Route path="/contact/form/*"                       element={ <ContactForm              /> } />
                    <Route path="/contact/wizard/*"                     element={ <Contact                  /> } />
                    <Route path="/gallery/*"                            element={ <Gallery                  /> } />
                    <Route path="/legal/privacy-policy/*"               element={ <LegalPrivacy             /> } />
                    <Route path="/legal/terms-and-conditions/*"         element={ <LegalTerms               /> } />
                    <Route path="/location/*"                           element={ <Location                 /> } />
                    <Route path="/marketing/unsubscribe/*"              element={ <MarketingUnsubscribe     /> } />
                    <Route path="*"                                     element={ <ErrorNotFound            /> } />
                </Routes>
            </main>
        </>
    );
}
